import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { HttpRequestInterceptor } from './app/interceptors/http-request.interceptor';
import { isDevMode } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      mode: 'ios',
      backButtonText: '',
      backButtonIcon: 'chevron-back',
      spinner: 'crescent',
      infiniteLoadingSpinner: 'crescent',
      loadingSpinner: 'crescent',
      refreshingSpinner: 'crescent',
      animated: true,
      swipeBackEnabled: false,
      hardwareBackButton: false,
      statusTap: true,
      sanitizerEnabled: true
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([HttpRequestInterceptor])), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }),
  ],
});
